<template>
  <div class="uploadImg">
    <!--  多图  -->
    <div class="picture" v-if="isList">
      <el-upload
        class="avatar-uploader-picture-card"
        :class="{'disabled':disabled}"
        :action="`${process.env.VUE_APP_CASTLE_URL}aliyun/oss/OSSController/starrycastle-security/uploadFile`"
        list-type="picture-card"
        :data="apiParams.params"
        :file-list="fileList"
        multiple
        :on-exceed="handleExceed"
        :limit="apiParams.limit||10"
        :on-success="handleExplainSuccess"
        :headers="headers"
        :on-remove="handleAbstractRemove"
        :before-upload="beforeAvatarUpload"
        :disabled="disabled"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <!--      <div class="suggest">-->
      <!--        <p>尺寸建议750x750（正方形模式）像素以上，大小2M以下，格式gif、jpeg、png、jpg、bmp，最多10张</p>-->
      <!--      </div>-->
    </div>

    <!-- 单图 -->
    <div class="cover" v-else>
      <el-upload
        class="avatar-uploader"
        :class="{'disabled':disabled}"
        :action="`${process.env.VUE_APP_CASTLE_URL}/aliyun/oss/OSSController/starrycastle-security/uploadFile`"
        :show-file-list="false"
        :data="apiParams.params"
        :on-success="handleAvatarSuccess"
        :headers="headers"
        :before-upload="beforeAvatarUpload"
        :disabled="disabled"
        v-loading="loading"
        :on-progress="uploadprogress"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <img
          v-if="params && params[apiParams.imgPath]"
          :src="params[apiParams.imgPath]"
          alt
          class="avatar"
        />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <!--      <div class="suggest">-->
      <!--        <p>尺寸建议750x750（正方形模式）像素以上，大小2M以下，格式gif、jpeg、png、jpg、bmp</p>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {}, //参数
    apiParams: {}, //请求参数
    isList: false, //是否多图上传
    disabled: {
      //禁止使用
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false, //正在上传loading
      headers: {
        token: sessionStorage.getItem("token")
      },
      imageUrl: "", //单个图片
      fileList: [], //图片列表
      fileIds: [] //图片列表id
      // params:{},
      // apiParams:{
      //   params:{  //文件上传所需要的参数
      //     catalog: '',
      //     loginKey: '',
      //   },
      //   imgPath: 'coverPath', //文件路径字段
      //   fileId: 'cover', //文件id字段
      // }
    };
  },
  created() {
    // this.apiParams.params.loginKey = sessionStorage.getItem('loginKey')
    if (Object.keys(this.params).length > 0) {
      this.fileListDispose();
    } else {
      this.needProps();
    }
  },
  methods: {
    //上传数量超过限制提醒
    handleExceed() {
      this.$message(`图片上传不能超过${this.apiParams.limit || 10}张`);
    },
    /* 监测Props */
    needProps() {
      let watchAch = this.$watch("params", (val, oldVal) => {
        if (val) {
          this.fileListDispose();
          watchAch(); //取消监听
        }
      });
    },
    /** 图片列表处理*/
    fileListDispose() {
      let filePaths = this.params[this.apiParams.imgPath]
        ? this.params[this.apiParams.imgPath].split("|")
        : [];
      this.fileIds = this.params[this.apiParams.fileId]
        ? this.params[this.apiParams.fileId].split(",")
        : [];
      for (let i = 0; i < filePaths.length; ++i) {
        this.fileList.push({
          id: this.fileIds[i],
          url: filePaths[i],
          status: "success"
        });
      }
    },
    /** 上传成功(单图)*/
    handleAvatarSuccess(file) {
      this.loading = false;
      this.imageUrl = file.obj.filePath;
      this.params[this.apiParams.fileId] = file.obj.fileId;
      this.params[this.apiParams.imgPath] = file.obj.filePath;
      this.$emit('upLoadImgsuccess',{
        fileId: file.obj.fileId,
        ziduan: this.apiParams.fileId,
        filePath: file.obj.filePath,
        filePathfield: this.apiParams.imgPath || ""
      });
    },

    /** 上传成功(多图)*/
    handleExplainSuccess(res, file) {
      this.fileIds.push(res.obj.fileId);
      this.params[this.apiParams.fileId] = this.fileIds.join(",");
    },
    /**
     * 删除图片处理-详情图
     */
    handleAbstractRemove(file, fileList) {
      let temp = this.common.clone(this.fileIds);
      for (let i = 0; i < temp.length; i++) {
        if (
          (file.id && temp[i] === file.id) ||
          (file.response && temp[i] === file.response.obj.fileId)
        ) {
          temp.splice(i, 1);
          break;
        }
      }
      this.fileIds = temp;
      this.params[this.apiParams.fileId] = this.fileIds.join(",");
    },

    /** 上传之前*/
    beforeAvatarUpload(file) {
      console.log(file);
      const fileType = file.name;
      const isLt = file.size / 1024 / 1024 < 0.5;

     let tuReg = /\.(png|jpg|gif|jpeg|bmp)$/;
      if (!tuReg.test(fileType)) {
        this.$message.error("图片格式错误，请重新选择!");
        return false;
      }
      if (!isLt) {
        this.$message.error("上传头像图片大小不能超过 500KB!");
        return false;
      }
      return tuReg.test(fileType) && isLt;
    },
    /*正在上传时 可设置进度条**/
    uploadprogress() {
      this.loading = true;
    }
  }
};
</script>

<style lang="scss">
.uploadImg {
  .cover,
  .picture {
    /*display: flex;*/

    .suggest {
      /*display: flex;*/
      /*align-items: flex-end;*/
      /*margin-left: 20px;*/
      margin-top: 14px;
      color: #aaa;
    }
  }

  .avatar-uploader {
    width: 80px;
    height: 80px;
    border-radius: 6px;
    /*background-color: #ECF0F5;*/
  }
  .avatar-uploader .el-upload {
    background-color: #f8f8f9;
  }
  .avatar-uploader .el-upload,
  .avatar-uploader-picture-card .el-upload {
    border: 1px solid #ecf0f5;
    width: 80px;
    height: 80px;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover,
  .avatar-uploader-picture-card .el-upload:hover {
    // border-color: #409eff;
  }
  .avatar-uploader-icon {
    display: flex;
    width: 100%;
    height: 100%;
    font-size: 28px;
    color: #ced2e0;
    justify-content: center;
    align-items: center;
  }
  .avatar {
    width: 100%;
    height: 100%;
    display: block;
  }

  .avatar-uploader-picture-card {
    border-radius: 6px;
    display: flex;
  }
  .avatar-uploader-picture-card .el-upload {
    background-color: #f8f8f9;
  }
  .el-upload-list .el-upload-list__item {
    width: 80px;
    height: 80px;
  }
  .disabled{
   opacity: 0.5;
  }
}
</style>
